import { FC, ReactNode } from 'react';
import styles from './AllFiltersLayout.css';
import { AdvancedFilter } from '../AdvancedFiltersLayout/components';
import { TAllFilter } from 'shared/types/filters';

interface IAllFilter {
  id: TAllFilter;
  component: ReactNode;
}

interface IAllFiltersLayoutProps {
  filters: IAllFilter[];
  pikBanner: ReactNode;
}

export const AllFiltersLayout: FC<IAllFiltersLayoutProps> = ({ filters, pikBanner }) => {
  return (
    <div className={styles['container']} data-testid="AllFilters">
      {pikBanner}
      {filters.map(({ id, component }) => (
        <AdvancedFilter dataTestId={id} key={`allFilter_${id}`}>
          {component}
        </AdvancedFilter>
      ))}
    </div>
  );
};
